import { getToken } from "@/core/hooks/useOfflineSession";

/**
 * Wrapper autour de fetch() qui ajoute automatiquement le header Authorization
 * avec le JWT token stocké dans localStorage.
 */
export function authFetch(
  input: string | URL | Request,
  init?: RequestInit
): Promise<Response> {
  const token = getToken();
  const headers = new Headers(init?.headers);

  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(input, { ...init, headers });
}
